export enum QueryParamNames {
  absentTeacherId = "at",
  searchTerm = "q",
}
